import { useCallback, useEffect, useMemo, useState, Suspense } from "react";
import { deleteItem, fetchData, toggleStatus } from "../../../utils/apiUtils";
import {
 ActionButton,
 PlusButton,
 ToggleSwitch,
} from "../../../helper/ImageFormat";
import DeleteModel from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import dateformate from "../../../helper/DateFormate";
const HomeSection = () => {
 const navigator = useNavigate();
 const [loading, setLoading] = useState(true);
 const [data, setData] = useState([]);
 const [search, setSearch] = useState("");
 const [deleteItemId, setDeleteItemId] = useState({});
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);
 const totalPages = useMemo(
  () => Math.ceil(totalCount / perPage),
  [totalCount, perPage]
 );
 const [nextPosition, setNextPosition] = useState(0);
 const fetchPaginationData = useCallback(
  async (page = 1, searchQuery = "") => {
   setLoading(true);
   await fetchData(
    "home-section-pagination",
    { perPage, pageNo: page, search: searchQuery },
    setData,
    setTotalCount,
    setCurrentPage,
    setLoading,
    setNextPosition
   );
  },
  [perPage]
 );
 useEffect(() => {
  const delay = search ? 500 : 0;
  const handler = setTimeout(() => {
   fetchPaginationData(currentPage, search);
  }, delay);
  return () => clearTimeout(handler);
 }, [search, perPage]);

 const handleDelete = (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };
 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem(
    "home-section",
    deleteItemId?.id,
    fetchPaginationData
   );
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (error) {
   return error;
  } finally {
   setIsDeleting(false);
  }
 };
 const handleStatusToggle = async (currency) => {
  const data = await toggleStatus(
   "home-section-status",
   currency?.id,
   fetchPaginationData
  );
  if (Object.keys(data).length > 0) {
   setData((prev) =>
    prev.map((curr) =>
     curr.id === currency.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };
 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchPaginationData(page);
  }
 };
 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Home Item", path: "/home-section" },
 ];
 const handleAdd = () => {
  navigator("/add-home-section", { state: { nextPosition } });
 };
 const handleEditClick = (item) => {
  navigator("/add-home-section", {
   state: item,
  });
 };
 const Tableheader = [
  "Sort Order",
  "Title",
  "Type",
  "Background Color",
  "Collection",
  "Product",
  "Catalogue",
  "CMS",
  "Updated At",
  "Is Active",
  "Action",
 ];
 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5 d-flex justify-content-between">
     <h3 className="custom-page-title">Home Section</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>
    <div
     className="d-flex justify-content-between mb-2 bg-white p-2"
     style={{ marginTop: "-20px" }}
    >
     <PerPageSelect value={perPage} onChange={setPerPage} />
     <div style={{ display: "flex", gap: "10px" }}>
      <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={handleAdd} module={"Home Item"} />
     </div>
    </div>

    <div className="row">
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <div className="table-responsive">
         <table className="custom-table table table-striped">
          <thead>
           <tr>
            {Tableheader.map((item, index) => (
             <th className="font-weight-bold " key={index}>
              {item}
             </th>
            ))}
           </tr>
          </thead>
          <tbody>
           {loading ? (
            <tr>
             <td colSpan="12" className="text-center">
              <Spinner />
             </td>
            </tr>
           ) : data.length > 0 ? (
            data.map((item, index) => (
             <tr key={index}>
              <td>{item.position}</td>
              <td>{item.title}</td>
              <td>{item.type}</td>
              <td>
               <div
                style={{
                 backgroundColor: item.bgcolor,
                 width: "40px",
                 height: "20px",
                 borderRadius: "4px",
                 border: "1px solid #000",
                }}
                title={item.bgcolor}
               />
              </td>

              {item?.type === "COLLECTION" ? (
               <td>
                <button
                 type="button"
                 className="count-button1"
                 onClick={() =>
                  navigator(`/home-items/${item?.id}`, { state: item })
                 }
                >
                 {item?.collectionCount}
                </button>
               </td>
              ) : (
               <td>--</td>
              )}

              <td>
               {item?.type === "PRODUCTS" || item?.type === "CATALOGUE" ? (
                <button
                 type="button"
                 className="count-button1"
                 onClick={() =>
                  navigator(`/home-items/${item?.id}`, { state: item })
                 }
                >
                 {item?.productCount}
                </button>
               ) : (
                "--"
               )}
              </td>

              <td>
               {item?.type === "CATALOGUE" || item?.type === "PRODUCTS" ? (
                <button
                 type="button"
                 className="count-button1"
                 onClick={() =>
                  navigator(`/home-items/${item?.id}`, { state: item })
                 }
                >
                 {item?.catalogueCount}
                </button>
               ) : (
                "--"
               )}
              </td>

              {item?.type === "CMS" ? (
               <td>
                <button
                 type="button"
                 className="count-button1"
                 onClick={() =>
                  navigator(`/home-items/${item?.id}`, { state: item })
                 }
                >
                 {item?.cmsCount}
                </button>
               </td>
              ) : (
               <td>--</td>
              )}
              <td>{dateformate(item.updatedAt)}</td>
              {/* <td>{dateformate(item.createdAt)}</td> */}
              <td>
               <ToggleSwitch
                data={item}
                name="isActive"
                checked={item.isActive}
                handleStatusToggle={handleStatusToggle}
                module={"Home Banners"}
               />
              </td>
              <td>
               <ActionButton
                data={item}
                handleEditClick={handleEditClick}
                handleDelete={handleDelete}
                module={"Home Banners"}
               />
              </td>
             </tr>
            ))
           ) : (
            <tr>
             <td colSpan="12" className="text-center">
              <h4>No data available</h4>
             </td>
            </tr>
           )}
          </tbody>
         </table>
        </div>

        {data?.length > 0 && (
         <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageClick}
          perPage={perPage}
          totalCount={totalCount}
         />
        )}
       </div>
      </div>
     </div>
    </div>
   </div>
   <Suspense fallback={<div>Loading...</div>}>
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="Home Section"
     isDeleting={isDeleting}
    />
   </Suspense>
  </>
 );
};

export default HomeSection;
